import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  DropDownItem,
  FilterItems,
  type ISelect,
} from '../../components/filters/filter.interface';
import {
  AccountFilters,
  IAccountDTO,
} from '../../interfaces/account/account.interface';
import { CommonGraphqlService } from '../common.graphql.service';
import { UserStateService } from '../users/user-state.service';
import {
  GridController,
  TSortDirections,
} from './../../classes/grid-page-info';

@Injectable({
  providedIn: 'root',
})
export class AccountStateService extends GridController<AccountFilters> {
  private _accounts: IAccountDTO[];

  private _filter: AccountFilters = {
    accountNumber: '',
    accountName: '',
    addressCity: '',
    state: '',
    vendor: '',
    taxId: '',
    providerGroupId: undefined,
    providerId: undefined,
    npi: '',
  };

  accountFilters: FilterItems = {
    filtersName: 'Accounts',
    items: [
      {
        name: 'accountNumber',
        caption: 'Account Number',
        type: 'text',
        placeholder: 'Enter Account Number',
      },
      {
        caption: 'Account Name',
        name: 'accountName',
        type: 'text',
        placeholder: 'Enter Account Name',
      },
      {
        caption: 'City',
        name: 'addressCity',
        type: 'text',
        placeholder: 'Enter City',
      },
      {
        caption: 'State',
        name: 'state',
        type: 'states',
        placeholder: 'Select State',
        asyncValues: undefined,
      },
      {
        caption: 'Vendor',
        name: 'vendor',
        type: 'select',
        placeholder: 'Select Vendor',
        asyncValues: undefined,
      },
      {
        caption: 'Tax ID',
        name: 'taxId',
        type: 'text',
        placeholder: 'Enter Tax ID',
      },
      {
        caption: 'Provider Group ID',
        name: 'providerGroupId',
        type: 'text',
        placeholder: 'Enter Provider Group ID',
      },
      {
        caption: 'Provider ID',
        name: 'providerId',
        type: 'text',
        placeholder: 'Enter Provider ID',
      },
      {
        caption: 'NPI',
        name: 'npi',
        type: 'text',
        placeholder: 'Enter NPI',
      },
    ],
  };

  override _sortDirections: TSortDirections = {
    accountNumber: 'ASC',
    name: '',
    city: '',
    state: '',
    vendor: '',
    contactName: '',
  };

  constructor(
    private commonGraphqlService: CommonGraphqlService,
    private userStateService: UserStateService,
  ) {
    super();
    this.init(this._filter, 1, 'accountNumber', 'ASC');

    const stateDropDown = this.accountFilters.items?.find((x) => {
      return x.name === 'state';
    }) as ISelect;
    stateDropDown.asyncValues = this.commonGraphqlService.getStates();

    const vendorDropDown = this.accountFilters.items?.find((x) => {
      return x.name === 'vendor';
    }) as ISelect;
    vendorDropDown.asyncValues = this.getApplications();
  }

  get accounts(): IAccountDTO[] {
    return this._accounts;
  }

  set accounts(value: IAccountDTO[]) {
    this._accounts = value;
  }

  getApplications(): Observable<DropDownItem[]> {
    const vendors = this.userStateService.user?.applications;
    const vendorCodes =
      vendors && vendors.length > 0
        ? vendors.map((x) => {
            return x.code;
          })
        : undefined;

    return this.commonGraphqlService
      .getApplications({ codes: vendorCodes })
      .pipe(
        map((apps) => {
          return apps.map((a) => {
            return { key: a.code, value: a.description };
          });
        }),
      );
  }
}
